<template>
  <div class="three_for">
    <div class="Cont Cont0" style="width: 90px;" v-if="showrate">
      <rate :type="type" :rate="item.rate" :newMajor="getnewmajor(item.list,scoreyear)"></rate>
    </div>
    <div class="Cont Cont1" style="width: 300px;padding-top: 10px;">
      <div class="Cont_TP">
        <img :src="($resourcesUrl+'/college/'+`${item.obj.college_id}`+'/'+`${item.obj.college_icon}`)" alt="">
        <p v-if="item.obj.college_code!=null&&item.obj.college_code!=''&&$utils.getlocalStorage('showcode')">
          代码:{{item.obj.college_code}}</p>
      </div>
      <div class="Cont_Nr">
        <p><router-link tag="a" target="_blank"
            :to="'/xyzy_jianjie?num=0&id='+item.obj.college_id">{{ item.obj.college_name }}</router-link></p>
        <p v-if="$utils.showflag(item.obj.college_info)" style="font-size: 14px;color: #c0c4cc;">
          {{ item.obj.college_info }}
        </p>
        <div class="Cont_Card">
          <span>{{AREA_OBJ[item.obj.college_area]}} /
          {{ item.obj.college_subject }} /
          <span :style="{color:item.obj.college_nature == 1?'':'red'}">{{item.obj.college_nature == 1?'公立':'民办'}}</span>
          <span v-if="item.college!=null&&item.college.area!=null"> / {{ item.college.area }}</span>
          </span>
        </div>
        <div class="Cont_Card" :style="{marginTop:item.college!=null?'5px':'12px'}" v-if="item.college!=null">
          <icollege :item="item"></icollege>
        </div>
        <div class="Cont_Card"
          v-if="item.obj.college_level!=null&&item.obj.college_level!=''">

          <el-tooltip effect="dark" placement="right">
            <div style="height: auto;width: auto; max-width: 350px;color: #ffffff;" slot="content">
              {{ item.obj.college_level.replace(/,/g,'、') }}
            </div>
            <span>
              {{ item.obj.college_level.length>18?item.obj.college_level.substring(0,18)+'...':item.obj.college_level }}
            </span>
          </el-tooltip>

        </div>

      </div>
    </div>

    <div class="Cont Cont6" v-if="tianbaoType==1||showtype=='majorscore'" :style="{width:showtype=='collegescore'||showtype=='majorscore'?'300px':'300px'}">
      <div class="Cont2_top" >
        <div style="display: flex;flex-direction: row;">
          <div v-if="item.obj.group_name!=null" style="background-color: #29A7E1;border-radius: 10px;height: 20px;line-height: 18px; padding: 0px 5px;margin-right: 5px;">
            <span style="font-size: 12px;line-height: 20px;color: #ffffff;">{{item.obj.group_name}}</span>
          </div>
          <div style="background-color: red;color: #ffffff;
          height: 20px;line-height: 20px; font-size: 12px;padding: 0 5px;border-radius: 8px;margin-right: 10px;"
          >{{item.obj.major_code}}</div>
          <div style="color: #29A7E1;">
            <span>
            <router-link tag="a" target="_blank" :to="'/zyxq_zhuanyejieshao?id='+item.obj.major_id">
              {{ item.obj.major_name }}
            </router-link></span>
          </div>
        </div>

        <imajor :item="item" ></imajor>
        <el-tooltip effect="dark" placement="right">
          <div style="height: auto;width: auto; max-width: 350px;color: #ffffff;" slot="content">
            {{ item.obj.major_info}}
          </div>
          <p style="font-size: 12px;" >
            <span v-if="item.obj.study_money!=null&&item.obj.study_money!=''" style="font-size: 12px;margin-right: 15px;">学费 : <span style="color: red;font-size: 12px;">{{ item.obj.study_money }}</span></span>
            <c v-if="item.obj.major_info!=null&&item.obj.major_info!=''" style="color: #666666">{{ item.obj.major_info.length>35?item.obj.major_info.substring(0,35)+'...':item.obj.major_info }}</c>
          </p>
        </el-tooltip>
      </div>
    </div>

    <div class="Cont Cont6" v-if="(tianbaoType==2&&showtype==null)||(tianbaoType==2&&showtype=='collegescore')" :style="{width:showtype=='collegescore'||showtype=='majorscore'?'300px':'300px'}">
      <div class="Cont2_top" style="text-align: left;align-items: center;width: 100%;">
        <span v-if="item.obj!=null" style="color: #333333; font-size: 14px; font-weight: normal;width: 100%;">专业分组
          <span style="color: #FF513E;">{{item.obj.group_name}}</span>


          <span v-if="tianbaoType==2" style="margin-top: 5px; margin-left: 10px; color: #333333;width: 100%; font-size: 14px;font-weight: normal;">分组选科：
            <span style="color: #FF513E;">{{ $utils.getZyShowXuanKe(item.obj)  }}</span>
          </span>
        </span>
        <span style="font-size: 14px;color: #666666;" v-if="item.obj.college_info!=null">
        ( {{item.obj.college_info}} ) </span>


        <span v-if="item.obj.zynum!=null" style="margin-top: 5px;color: #333333; font-size: 14px;width: 100%;font-weight: normal;">专业数量：
          ( <span style="color: #FF513E;">{{item.obj.zynum}}</span>
          <span style="color: green;" v-if="num !=0" >/  {{num}}</span> )
        </span>
        <el-tooltip effect="dark" placement="bottom">
          <div style="height: auto;width: auto; max-width: 350px;color: #ffffff;" slot="content">
            {{ item.obj.major_name}}
          </div>
          <p style="font-size: 12px;width: 100%;margin-top: 5px;">
            <span v-if="item.obj.major_name!=null" style="font-size: 12px;color: #333333;margin-right: 5px;">包含专业 : <span style="color: #FF513E;font-size: 12px;">{{ item.obj.study_money }}</span></span>
            {{ item.obj.major_name.length>18?item.obj.major_name.substring(0,18)+'...':item.obj.major_name }}
          </p>
        </el-tooltip>

      </div>
    </div>



    <div class="Cont Cont7" style="width: 70px;display: flex;flex-direction: column;justify-content: center;" >
      <p>{{ showinfo(item.obj.plan_num) }}</p>
      <p style="font-size: 12px;" v-if="item.obj.planflag!=null&&item.obj.planflag!=0">
        <span v-if="item.obj.planflag>=0" style="color: #05e805;">增  </span>
        <span v-if="item.obj.planflag<0" >减  </span>
        {{Math.abs(item.obj.planflag)}}人
        </p>
      <p  style="font-size: 12px;">({{ $utils.getZyShowXuanKe(item.obj)  }})</p>
    </div>
    <div class="Cont Cont8" style="width: 430px;">
      <div v-for="(info, index2) in getscore(item.list,scoreyear)" :key="index2" class="scoreInfo">
        <div class="Cont8_B" :style="{width: listw[0]}" >{{ showinfo(info.scoreYear) }}</div>
        <div class="Cont8_B" :style="{width: listw[1]}">{{ showinfo(info.scorePlanNum) }}/{{ showinfo(info.scoreTakeNum) }}</div>
        <div class="Cont8_B" :style="{width: listw[2]}">{{ showinfo(info.scoreMin) }}</div>
        <div class="Cont8_B" :style="{width: listw[3]}" v-if="showflag">{{ showinfo(info.spare1) }}</div>
        <div class="Cont8_B" :style="{width: listw[4]}" >{{ showinfo(info.spare2) }}</div>
        <div class="Cont8_B" :style="{width: listw[6]}" >{{ info.scoreMinRank }}</div>
        <div class="Cont8_B" :style="{width: listw[5]}"  >
        <span  :style="{color:$utils.getScorecolor(score.score,info.spare2,1)}">{{ $utils.getScoreCha(score.score,info.spare2,1) }}</span>
        /<span  :style="{color:$utils.getScorecolor(score.scoreRank,info.scoreMinRank,0)}">{{ $utils.getScoreCha(score.scoreRank,info.scoreMinRank,0) }}</span>
        </div>
      </div>
    </div>
    <div class="Cont Cont9" :style="{width: showrate?'88px':'168px'}"  style="flex-direction: column;justify-content: center;">
      <div :class="{Cont9_A:!flag,Cont9_B:flag}" @click="zzc" v-if="showtype == null||showtype == ''">
        <p>{{flag?'已选志愿':'填报志愿'}}</p>
      </div>
      <div class="Cont9_A" style="margin-bottom: 10px;" @click="zzc" v-if="tianbaoType==2&&!(showtype == null||showtype == '')">
        <p>查看专业</p>
      </div>
      <div :class="{Cont9_A:!flag,Cont9_B:flag}" @click="guanzu(item.obj.plan_id)" v-if="!(showtype == null||showtype == '')">
        <p>{{flag?'已关注':'+关注'}}</p>
      </div>

    </div>
  </div>
</template>

<script>
  import rate from '../rateInfo.vue'
  import icollege from "../icollege.vue";
  import imajor from "../imajor.vue";
  export default {
    props: {
      item: {
        type: Object
      },
      type: {
        type: String
      },
      index: {
        type: Number
      },
      checked: {
        type: Boolean
      },
      showtype: {
        type: String,
        default: null
      },
      scoreyear: {
        type: Number
      },
      showrate:{
        type: Boolean,
        default: true
      }
    },
    components: {
      rate,
      icollege,
      imajor
    },
    watch: {
      checked(val) {
        console.log(val)
        this.flag = val
      }
    },
    data() {
      return {
        AREA_OBJ: this.$utils.getlocalStorage("AREA_OBJ"),
        flag: this.item.checked,
        num: 0,
        tianbaoType: this.$utils.getlocalStorage('tianbaoType'),
        role: parseInt(this.$utils.getlocalStorage("userInfo").userRole),
        rlist: [],
        score: this.$utils.getlocalStorage("scoreInfo"),
        userId: this.$utils.getlocalStorage("userInfo").userId,
        newMajor: true,
        listw:['50px','70px','50px','50px','50px','100px','60px'],
        showflag:false,

      }
    },
    created() {
      this.rlist = this.$utils.getHeardrList(this.tianbaoType, this.showtype)
      this.showflag = this.role==3||this.role==2
      if(this.showflag){
        this.listw = ['50px','70px','50px','50px','50px','100px','60px']
      } else {
        this.listw = ['60px','75px','50px','55px','60px','105px','70px']
      }
      this.getData();
    },
    methods: {
      toBreak(college) {
        let str = '';
        if (college.areaji != null) {
          str += college.areaji + " : " + college.area + '<br/>'
        }
        if (college.byFlag != null) {
          str += "保研率 : " + college.byRate + '%<br/>'
        }
        if (college.rk != null) {
          str += "软科 : " + college.rk + '<br/>'
        }
        if (college.xyh != null) {
          str += "校友会 : " + college.xyh + '<br/>'
        }
        if (college.yjxy != null) {
          str += "研究生院 : " + college.yjxy + '<br/>'
        }
        if (college.yange != null) {
          str += "历史沿革 : " + college.yange + '<br/>'
        }
        return str;
      },
      getnewmajor(list, scoreYear) {
        let a = this.getscore(list, scoreYear, 0)
        if(a.length!=0){
          if (a[0].scoreMin == '--' && a[1].scoreMin == '--' && a[2].scoreMin == '--') {
            // this.newMajor = -1;
            return false;
          } else if (a[0].scoreActual == '0') {
            return false;
          }
        }

        return true;
      },
      getscore(list, scoreYear, flag) {
        let _this = this;
        let listr = []
        let ad = {
          scoreYear: "--",
          scorePlanNum: "--",
          scoreMin: "--",
          scoreMinRank: "--",
          scoreXiancha: '--'
        };
        if (list != null) {
          if (list.length < 3) {
            if (list.length == 2) {
              if (list[0].scoreYear == scoreYear) {
                listr.push(list[0])
                if (list[1].scoreYear == scoreYear - 1) {
                  listr.push(list[1])
                  listr.push(ad)
                } else {
                  listr.push(ad)
                  listr.push(list[1])
                }
              } else {
                listr.push(ad)
                listr.push(list[0])
                listr.push(list[1])
              }
            } else if (list.length == 1) {
              if (list[0].scoreYear == scoreYear) {
                listr.push(list[0])
                listr.push(ad)
                listr.push(ad)

              } else if (list[0].scoreYear == scoreYear - 1) {
                listr.push(ad)
                listr.push(list[0])
                listr.push(ad)
              } else if (list[0].scoreYear == scoreYear - 2) {
                listr.push(ad)
                listr.push(ad)
                listr.push(list[0])
              }
            } else {
              listr.push(ad)
              listr.push(ad)
              listr.push(ad)
            }
          } else {

            listr.push(list[0])
            listr.push(list[1])
            listr.push(list[2])
          }
        } else {
          listr.push(ad)
          listr.push(ad)
          listr.push(ad)
        }
        for (let i = 0; i < listr.length; i++) {
          if (listr[i].scoreMin + "" == null || listr[i].scoreMin + "" == '') {
            listr[i] = ad;
          } else if (flag == undefined) {
            if (listr[i].scoreMin + "" == "0") {
              listr[i] = ad;
            }
          } else if (flag != undefined) {
            if (listr[i].scoreMin + "" == "0" && listr[i].scoreActual + "" != "0") {
              listr[i] = ad;
            }
          }
        }
        return listr;

      },
      getData() {
        if (!this.$utils.showflag(this.showtype)) {
          let map = this.$utils.getlocalStorage("ZhiYuan" + this.type);
          if (map != null) {
            if (this.tianbaoType == 2) {
              this.flag = map.ids.indexOf(this.item.dataid) != -1
              if (this.flag) {
                if(map.map[this.item.dataid].ids!=null){
                  this.num = map.map[this.item.dataid].ids.length
                }
              } else {
                this.num = 0
              }
            } else if (this.tianbaoType == 1) {
              this.flag = map.ids.indexOf(this.item.id) != -1
            } else if (this.tianbaoType == 0) {
              this.flag = map.ids.indexOf(this.item.id) != -1
              if (this.flag) {
                this.num = map.map[this.item.id].ids.length
              } else {
                this.num = 0
              }
            }
          } else {
            this.flag = false;
          }
        } else {
          this.flag = this.$utils.getlocalStorage("userCang")[this.showtype].indexOf(this.item.obj.plan_id) != -1
        }

      },
      zzc() {
        this.$emit("select", this.index, !this.flag, this.item)
      },
      changeflag(checked) {
        this.flag = checked
      },
      guanzu(id) {
        let _this = this;
        let obj = this.$utils.getlocalStorage("userCang")
        let list = obj[this.showtype]
        if (!this.flag) {
          _this.$req.insert("collectionTable", {
            dataType: this.showtype == "collegescore" ? 3 : 4,
            dataId: id,
            userId: this.userId
          }).then(function(resp) {
            if (resp.status == 0) {
              list.push(id);
              _this.flag = true;
              obj[_this.showtype] = list
              _this.$utils.setlocalStorage("userCang", obj);
            }
          })

        } else {
          _this.$req.batchDelete("collectionTable", {
            data_type: this.showtype == "collegescore" ? 3 : 4,
            data_id: id
          }).then(function(resp) {
            if (resp.status == 0) {
              list.splice(list.indexOf(id), 1);
              _this.flag = false;
              obj[_this.showtype] = list
              _this.$utils.setlocalStorage("userCang", obj);
            }
          })
        }
      },
      openmajor(item) {
        this.$emit("select", item)
      },
      showinfo(info) {
        if (info == null || info == '') {
          return '--';
        }
        return info;
      },
    }
  }
</script>

<style scoped>
  .mytag {
    height: 18px;
    line-height: 16px;
    padding: 0 5px;
  }

  .three_for {
    display: flex;
    width: 1280px;
    justify-content: start;

    height: auto;
    /* border: 1px solid #ebe9e9;
    border-radius: 10px;
    margin-top: 11px; */
    border: 1px solid #95989e;
    border-radius: 10px;
    margin-top: 10px;
  }

  .openmajorc {
    width: 82px;
    height: 30px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #29a7e1;
    color: #29a7e1;
    text-align: center;
    opacity: 1;
    margin-top: 10px;
    border-radius: 5px;
    line-height: 30px;
    font-size: 15px;
  }

  .Cont0 {
    width: 7%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .Cont1 {
    width: 21%;
    height: auto;

    padding-left: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .Cont {
    border-right: 1px solid #ebe9e9;
  }

  .Cont2 {
    width: 4%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 32px;
  }

  .Cont3 {
    width: 4%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 32px;
  }

  .Cont4 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 6%;
    height: auto;
    text-align: center;
    /* line-height: 169px; */
  }

  .Cont5 {
    width: 4%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 32px;
  }

  .Cont6 {
    /* display: flex;
      align-items: center;
      justify-content: center;
      width: 8%;
      height: 100%;
      text-align: center;
      cursor: pointer; */
    width: 13%;
    display: flex;
    padding: 0 5px 0 15px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .Cont2_top {
    justify-content: center;
    display: flex;
    flex-direction: column;
    min-height: 105px;
    width: 100%;
  }

  .Cont2_top h4,
  span {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 20px;
    color: #F53824;
  }

  .Cont2_bot p {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 17px;
    color: #999999;
    opacity: 1;
  }



  .Cont7 {
    width: 4%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 25px;
  }

  .Cont8 {
    width: 25%;
    height: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    /* border: none; */
  }

  .scoreInfo {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: start;
    height: 33.33%;
    font-size: 14px;

  }
  .scoreInfo span {
    font-size: 14px;
  }

  .Cont8_A {
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    border-right: 1px solid #ebe9e9;
  }

  .Cont8_AA {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29a7e1;
  }

  .Cont8_B {
    width: 20%;
    height: 100%;
    line-height: 100%;
    border-bottom: 1px solid #ebe9e9;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Cont9 {
    width: 8%;
    height: auto;
    text-align: center;
    line-height: 32px;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Cont9 .Cont9_A {
    display: flex;
    justify-content: center;
    width: 75px;
    height: 30px;
    border: 1px solid #F53824;
    border-radius: 5px;
    align-items: center;
    cursor: pointer;
  }

  /* 点击关注 切换 */
  .Cont9 .Cont9_B {
    display: flex;
    justify-content: center;
    width: 75px;
    height: 30px;
    background: #F53824;
    background-size: 92px 36px;
    align-items: center;
    cursor: pointer;
    color: white;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    border-radius: 5px;
  }

  .Cont9_B p {
    color: #ffffff;
  }

  .Cont9_A p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
  }

  .Cont10 {
    width: 4%;
    height: auto;
    text-align: center;
    line-height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Cont11 {
    width: 17%;
    height: auto;
    text-align: center;
    line-height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Cont_img {
    width: 110px;
    height: 110px;
  }

  .Cont_TP {
    display: flex;
    flex-direction: column;
  }

  .Cont_TP img {
    width: 68px;
    height: 68px;
  }

  .Cont_TP p {
    display: block;
    width: 68px;
    height: 28px;
    background: rgba(242, 242, 242, 0.39);
    border-radius: 5px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 20px;
    color: #F53824;
    text-align: center;
    line-height: 28px;
    margin-top: 10px;
  }

  .Cont_Nr {
    flex: 1;
    margin-left: 14px;
  }

  .Cont_Nr p {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
  }

  .Cont_Card {
    margin-top: 5px;
  }

  .Cont_Card span {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 18px;
    color: #333333;
    opacity: 1;
  }

  _for .Cont2 p {
    font-size: 16px;
    font-family: MicrosoftYaHei;
  }

  /* .Cont6 p {
      width: 92px;
      height: 36px;
      background: rgba(255, 255, 255, 0.39);
      border: 1px solid #29a7e1;
      color: #29a7e1;
      opacity: 1;
      border-radius: 5px;
      line-height: 36px;
      font-size: 16px;
    } */

  _for .Cont3 p,
  _for .Cont4 p,
  _for .Cont5 p,
  _for,
  _for .Cont7 p {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/components/tianbaoInfo/newgkmajorInfo.vue